import type { IconProps } from './types';

export const ChevronUpIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M2.15625 17.1562L12 7.3125L21.8438 17.1562" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
